// @ts-nocheck

document.addEventListener("DOMContentLoaded", function () {
  const inputWorkspaceLink = document.getElementById("js-input_workspace_link");
  if (inputWorkspaceLink) {
    inputWorkspaceLink.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("js-sign_in_content").style.display = "none";
      document.getElementById("js-input_workspace_link").style.display = "none";
      document.getElementById("js-sso_sign_in_content").style.display = "block";
      document.getElementById("js-forgot_your_password").style.display = "none";
      document.getElementById("js-didn_t_receive_confirmation_instructions").style.display = "none";
    });

    const SignInLink = document.getElementById("js-sing_in_link");
    SignInLink.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("js-sign_in_content").style.display = "block";
      document.getElementById("js-input_workspace_link").style.display = "block";
      document.getElementById("js-sso_sign_in_content").style.display = "none";
      document.getElementById("js-forgot_your_password").style.display = "inline-block";
      document.getElementById("js-didn_t_receive_confirmation_instructions").style.display = "inline-block";
    });
  }
});
